import herald_sticky_sidebar from "../functions/herald_sticky_sidebar";
import herald_sidebar_switch from "../functions/herald_sidebar_switch";
import herald_sticky_meta_bar from "../functions/herald_sticky_meta_bar";
import herald_sticky_bottom_bar from "../functions/herald_sticky_bottom_bar";
import herald_align_full_fix from "../functions/herald_align_full_fix";
import herald_popup_image from "../functions/herald_popup_image";
import herald_popup_image_content from "../functions/herald_popup_image_content";
import herald_popup_gallery from "../functions/herald_popup_gallery";
import herald_widget_slider from "../functions/herald_widget_slider";
import herald_gallery from "../functions/herald_gallery";
import clear_blur from "./clear_blur";

export default function() {
  clear_blur();

  imagesLoaded( 'body', function() {
    herald_sticky_sidebar();
    herald_sidebar_switch();
    herald_sticky_meta_bar();
    herald_sticky_bottom_bar($('.herald-site-content .herald-section').last());
    $('.herald-clear-blur').clearBlur();
  });

  herald_align_full_fix();

  herald_popup_image_content($('.herald-section'));

  if (herald_js_settings.popup_img) {
    herald_popup_image($('.herald-site-content'));
    herald_popup_gallery($('.herald-site-content'));
  }

  herald_widget_slider($("body"));
  herald_gallery($("body"));
}
